<div class="flap-title">Nouvelle activité</div>
<div [formGroup]="form">
  <app-control codeLabel="nomComptable" class="col-12 col-xl-5">
    <input type="text" maxlength="40" formControlName="nomComptable" class="form-control" />
  </app-control>

  <app-control codeLabel="codeAnalytique" class="col-12 col-xl-5">
    <input
      type="text"
      formControlName="codeAnalytique"
      title="8 caractères ( chiffres et lettres majuscules )"
      class="form-control"
      maxlength="8"
      app-restrict-input
      [InputRestriction]="'^[A-Z0-9_]*$'"
      phAuto
    />
  </app-control>

  <button type="button" class="btn btn-primary position-relative" [disabled]="!form.valid || saving" (click)="save()">
    @if (saving) {
      <app-button-spinner></app-button-spinner>
    }
    Enregistrer
  </button>
</div>
